import React, { useEffect, useState, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import useAppVisitTracker from './hooks/useAppVisitTracker';
import StreakMilestoneModal from './components/StreakMilestoneModal';
import Home from './pages/Home';
import Admin from './pages/Admin';
import Profile from './pages/Profile';
import Following from './pages/Following';
// import DebugInfo from './components/DebugInfo';
import './App.css';

// Helper component to add class to body based on route
function ScrollManager() {
  const location = useLocation();
  
  useEffect(() => {
    // Add admin-page class to body when on admin route
    if (location.pathname === '/admin') {
      document.body.classList.add('admin-page');
      document.documentElement.classList.add('admin-page');
    } else {
      document.body.classList.remove('admin-page');
      document.documentElement.classList.remove('admin-page');
    }
    
    // Scroll to top on route change
    window.scrollTo(0, 0);
  }, [location]);
  
  return null;
}

// Component to track app visits for streaks
function AppVisitTracker({ onStreakUpdate }) {
  useAppVisitTracker(onStreakUpdate);
  return null;
}

function App() {
  const [streakModalData, setStreakModalData] = useState(null);
  const [showStreakModal, setShowStreakModal] = useState(false);


  const handleStreakUpdate = useCallback((streakResult) => {
    // Show modal for streak updates (new visits)
    setStreakModalData(streakResult);
    setShowStreakModal(true);
  }, []);

  const closeStreakModal = () => {
    setShowStreakModal(false);
    setStreakModalData(null);
  };

  return (
    <AuthProvider>
      <NotificationProvider>
        <Router>
          <ScrollManager />
          <AppVisitTracker onStreakUpdate={handleStreakUpdate} />
          <div className="app">
            {/* <DebugInfo /> */}
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/question/:questionId" element={<Home />} />
              <Route path="/following" element={<Following />} />
              <Route path="/categories" element={<Home />} />
              <Route path="/hot" element={<Home />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/profile/:userId" element={<Profile />} />
            </Routes>
          </div>
          
          {/* Streak Milestone Modal */}
          <StreakMilestoneModal
            isOpen={showStreakModal}
            onClose={closeStreakModal}
            streakData={streakModalData}
            isNewStreak={streakModalData?.currentStreak === 1}
            wasStreakBroken={streakModalData?.streakBroken}
          />
        </Router>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;